import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import leaf from "../../Assets/Projects/h&m.png";
import beardo from "../../Assets/Projects/beardo.png";
import chatify from "../../Assets/Projects/nordstrom.png";
import tumbler from "../../Assets/Projects/tumbler.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Nordstromrack"
              description="Nordstrom Rack is an American off-price department store chain founded in 1973, and a subsidiary of the luxury department store chain Nordstrom. Nordstrom Rack offers branded clothing and accessories for women, men, and kids at a large discount to consumers across the United States and Canada."
              live="https://github.com/kanhaiya-k/nordstromrack-clone"
              link="https://nordstromrack-clone.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="H&M"
              description="H&M is a family of brands, driven by our desire to make great design available to everyone in a sustainable way. Together we offer fashion, design and services, that enable people to be inspired and to express their own personal style, making it easier to live in a more circular way."
              live="https://github.com/kanhaiya-k/HandM-india-clone"
              link="https://hm-india-clone.netlify.app/index.html"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={beardo}
              isBlog={false}
              title="Beardo.in"
              description="Beardo is a Ahmedabad-based men's grooming brand and start-up that sells beard oils, beard waxes, soaps and other grooming products. It is owned by Zed Lifestyle Pvt. Ltd. Beardo was founded in 2015 by Ashutosh Valani and Priyank Shah."
              live="https://github.com/kanhaiya-k/beardo_clone"
              link="https://beardo-clone.vercel.app/products/landingpage.html"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tumbler}
              isBlog={false}
              title="Tumbler"
              description="Tervis.com is an E-commerce website that offers numerous sizes, water bottles, sippy cups and wine glasses, 1000s of original and licensed designs and emblems, and a full complement of accessories. The third-generation family-owned-and-operated business now employs more than 900 people and is celebrating 70 years of success.
            "
              live="https://github.com/kanhaiya-k/tumbler-1"
              link="https://tervis-clone.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
